import { fork } from 'redux-saga/effects';

import me from 'store/me/saga';
import test from 'store/test/saga';

export default function* rootSaga() {
  yield fork(me);
  yield fork(test);
}
